"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var memoize = require("lodash/memoize");
exports.getDefaultDate = function () {
    var date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString().split('.')[0] + 'Z';
};
exports.normalizeDateTime = memoize(function (timestamp) {
    var d = new Date(timestamp);
    if (isNaN(d.getTime())) {
        return 'Invalid date';
    }
    return d.toISOString().split('.')[0] + 'Z';
});



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/DataTypes/date-time-helpers.js
// module id = 630
// module chunks = 2